import { getContext } from "svelte";
import type { DocumentsStore } from "./documents";
import type { UserStore } from "./user";
import type { UserPreferencesStore } from "./userPreferences";

export type Stores = {
  docs: DocumentsStore;
  user: UserStore;
  userPreferences: UserPreferencesStore;
};

export const getStores = () => {
  const docs = getContext<DocumentsStore>("docs");
  const user = getContext<UserStore>("user");
  const userPreferences = getContext<UserPreferencesStore>("userPreferences");
  return { docs, user, userPreferences };
};
